import script from '../LineItemQuantityForm';

export default { ...script };
